import { useState, useCallback, useEffect } from "react";
import SectionContainer from "../../components/UI/SectionContainer";
import UserSearchBox from "../../components/UI/UserSearchBox";
import Pagination from "../../components/UI/Pagination";
import DateTimeCell from '../../components/UI/DateTimeCell';
import { openAlert, exportExcel, showPopup } from '../../utils/common';
import Spinner from '../../components/UI/Spinner';
import bluetoothService from '../../services/bluetoothService';

const ReportListPage = () => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchKind, setSearchKind] = useState('0');
    const [keyword, setKeyword] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const pageSize = 10;
    const pageBlock = 5;

    const fetchList = useCallback(async (page = 1, skArg, kwArg) => {
      setLoading(true);
      try {
        const sk = skArg !== undefined ? Number(skArg) : 0;
        const kwState = kwArg !== undefined ? kwArg : '';

        const result = await bluetoothService.getBluetoothDeviceList({
          page,
          pageSize,
          keyword: kwState,
          searchKind: sk
        });

        if (result.success) {
          setList(result.data?.devices || []);
          setTotalCount(result.data?.pagination?.totalCount || 0);
        } else {
          openAlert({ title: '알림', description: result.message });
        }
      } catch (e) { 
        console.error(e); 
        openAlert({ title: '알림', description: '데이터 로드 중 오류가 발생했습니다.' });
      } finally {
        setLoading(false);
      }
    }, []);

    useEffect(() => {
      fetchList(currentPage, searchKind, keyword);
    }, [currentPage]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleSearch = (directKeyword) => { 
      setCurrentPage(1); 
      // Use directKeyword if provided (from suggestion select), otherwise use keyword from state
      fetchList(1, searchKind, directKeyword !== undefined ? directKeyword : keyword); 
    };
    const handleReset = () => { 
      setSearchKind('0'); 
      setKeyword(''); 
      setCurrentPage(1); 
      // Call fetchList directly with reset values, consistent with new handleSearch signature
      fetchList(1, '0', ''); 
    };

    const showUserReport = (idx) => {
        showPopup(`/user/report/${idx}`, 'userinfo');
    }

    const handleExcelDownload = async () => {
        setLoading(true);
        try {
            const result = await bluetoothService.getReportExcelData(keyword, Number(searchKind));

            if (result.success) {
              const excelConfig = {
                  excelFileName : "보고서 회원.xlsx",
                  sheetName : "Sheet1"
              }
              exportExcel(result.data, excelConfig);
            } else {
              openAlert({ title: '알림', description: result.message });
            }

        } catch (e) {
            console.error(e);
            openAlert({ title: '알림', description: '엑셀 다운로드 중 오류가 발생했습니다.' });
        } finally {
            setLoading(false);
        }
    }

    return (
        <SectionContainer title="회원별 보고서 관리">
            <UserSearchBox
              value={keyword}
              onChange={setKeyword}
              searchKind={searchKind}
              onSelect={setSearchKind}
              onSearch={handleSearch}
              onReset={handleReset}
              onSuggestSelect={selectedVal => { 
                setKeyword(selectedVal); // Update the keyword state
                handleSearch(selectedVal); // And immediately search with this selected value
              }}
              totalCount={totalCount}
              showTotalCount={false}
              onExcelDownload={handleExcelDownload}
              customFetchSuggestions={bluetoothService.getSearchSuggest}
            />
            <div className="content_area">
              <Spinner visible={loading} />
              <div className="table_area">
                <div className="table">
                  <table className="report-list-table">
                    <thead>
                      <tr>
                        <th>성명</th>
                        <th>아이디</th>
                        <th>이메일</th>
                        <th>가입일</th>
                        <th>비고</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!loading && list.length === 0 ? (
                        <tr><td colSpan="5">내역이 존재하지 않습니다.</td></tr>
                      ) : (
                        list.map((item, idx) => (
                          <tr key={idx}>
                            <td style={{cursor: 'default'}}>{item.userName}</td>
                            <td style={{cursor: 'default'}}>{item.userId}</td>  
                            <td style={{cursor: 'default'}}>{item.userEmail}</td>
                            <DateTimeCell value={item.userRegDate} style={{cursor: 'default'}} />
                            <td style={{cursor: 'default'}}>
                              <div className="but-flex">
                                <div className="t_but mr-1" onClick={() => showUserReport(item.userIdx)}>보고서</div>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <Pagination currentPage={currentPage} totalCount={totalCount} pageSize={pageSize} pageBlock={pageBlock} onPageChange={setCurrentPage} />
        </SectionContainer>
    );
}

export default ReportListPage; 